const estatus = [
  { id: true, label: 'Habilitado' },
  { id: false, label: 'Inhabilitado' },
];

export default estatus
